<template>

    <div class="show show_block show_empty mb-5" v-if="isActive" @change="sendDataForSaving" >
        <div class="row">
            <div class="col-12">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Title Show*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="form.show_title"
                    >
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group mb-3">
                    <label for="" class="form-label">Show Duration*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="form.show_duration"
                    >
                </div>
            </div>
            <div class="col-12">
                <div class="form-group mb-5">
                    <label for="" class="form-label">Description*</label>
                    <textarea
                        class="form-control pl-4"
                        v-model="form.show_description"
                    ></textarea>
                </div>
            </div>
        </div>
        <div class="show__actions show__actions_bottom">
            <button
                class="show__cancel"
                @click="$emit('removeShow',{index: index, type: 'shows' })"
            >Cancel</button>

            <span class="show__sep"></span>

            <button
                class="show__save"
                @click="closeForm"
            >
                Save
            </button>
        </div>
    </div>

    <div class="show show_block" v-else >
        <div class="show__actions">
            <a
                @click="$emit('activate', index)"
                href="javascript:void(0)"
                class="show__edit"

            >Edit</a>
            <span class="show__sep"></span>

            <a
                @click="$emit('removeShow',{index: index, type: 'shows' })"
                href="javascript:void(0)"
                class="show__delete"
                area-label="Delete"
            >
                <svg width="16" height="16" class="icon">
                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                </svg>
            </a>
        </div>
        <h3 class="show__title">{{ form.show_title }}</h3>
        <span class="show__time">
            Show duration: <span class="color_primary">{{ form.show_duration }}</span>
        </span>
        <div class="show__block view">
            <ul class="show__list">
                <li> {{form.show_description}}</li>
            </ul>
        </div>
        <button
            type="button"
            class="show__more"
            @click="hideText"
        >
            <span>More</span><em>Less</em>
        </button>
    </div>



</template>

<script>
export default {
    name: 'ShowForm',
    props: {
        isActive: {
            type: Boolean
        },
        index: Number,
        show: {
            type: Object
        }
    },

    data() {
        return {
           form: {
               index: this.index,
               show_title: null,
               show_duration: null,
               show_description: null
           }
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form, 'shows');
        },
        closeForm() {
            this.$emit('saveShowForm',  null);
        },
        setData() {
            Object.keys(this.show).forEach((key) => {
                this.form[key] = this.show[key] ?? null;
            });
        },
        hideText() {

        }
    },
    mounted() {
        this.setData()
    },
    watch: {
        show: {
            handler: function (newInfo) {
                if (newInfo !== this.form) {
                    this.setData();
                }
            },
            immediate: true,
        },
    }
}

</script>



<style scoped>

</style>
